import { observer } from 'mobx-react-lite'
import { DS } from '../../../../../design-system'
import { useStore } from '../../../../../models'
import MicIconOff from '../../../assets/Mic--off.svg'
import { StyleSheet, View } from 'react-native'
import { PlayerCellVideo } from '../../../PlayerCell/PlayerCellVideo'

export interface BetModalActionsProps {
  onClose: () => void
  onConfirm: () => void
  isConfirmDisabled?: boolean
}

export const BetModalActions = observer(({ onClose, isConfirmDisabled, onConfirm }: BetModalActionsProps) => {
  const {
    game: { isBetModalOpen },
    communication: { isLocalUserJoined, isLocalUserVideoHidden, isLocalUserMuted }
  } = useStore()

  const showVideo = isLocalUserJoined && !isLocalUserVideoHidden && isBetModalOpen
  const showAudioIcon = isLocalUserJoined && isLocalUserVideoHidden && !isLocalUserMuted
  const showMuted = isLocalUserJoined && isLocalUserVideoHidden && isLocalUserMuted

  return (
    <DS.Frame gap={'16'} row>
      {showMuted ? (
        <View style={styles.audioIconContainer}>
          <MicIconOff />
        </View>
      ) : null}
      {showVideo ? <PlayerCellVideo videoStyle={{ borderRadius: 24, width: 48, height: 48 }} /> : null}
      {showAudioIcon ? (
        <View style={styles.audioIconContainer}>
          <DS.Icon name="Audio" size={24} color={'Global/Black'} />
        </View>
      ) : null}
      <DS.Button variant="Large/Secondary" type="On Dark" onPress={onClose} maxWidth>
        Cancel
      </DS.Button>
      <DS.Button
        variant="Large/Primary"
        type={'On Light'}
        disabled={isConfirmDisabled}
        onPress={!isConfirmDisabled ? onConfirm : undefined}
        maxWidth
      >
        Confirm
      </DS.Button>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  audioIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: DS.palette['Global/White'],
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  }
})
